import { Stack, Typography } from '@mui/material';
import { CloudController, DoorType } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { getLockIcon } from 'utils/Lock/Lock';
import InfoGrid from 'v2/components/InfoGrid/InfoGrid';
import SectionPaper from 'v2/components/SectionPaper/SectionPaper';

interface Props {
  cloudController: CloudController;
}

const CloudControllerInfo: React.FC<Props> = ({ cloudController }) => {
  const { translation } = useTranslation();

  return (
    <SectionPaper>
      <Stack spacing={2}>
        <Typography variant="h5">{translation.device_info}</Typography>
        <InfoGrid equalColumns>
          <InfoGrid.Label>{translation.serial_number}</InfoGrid.Label>
          <InfoGrid.Text>{cloudController.serialNumber}</InfoGrid.Text>

          <InfoGrid.Label>{translation.device_type}</InfoGrid.Label>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="body2">{translation.cloud_controller}</Typography>
            {getLockIcon({ type: DoorType.CloudControllerDoor }, { color: 'action' })}
          </Stack>
        </InfoGrid>
      </Stack>
    </SectionPaper>
  );
};

export default CloudControllerInfo;
